<div
  class="de-snackbar"
  [@slideInOut]="{ value: animationStep, params: { direction: getAnimationPercentage() } }"
  [ngClass]="{
    'de-snackbar--default': type === 'default',
    'de-snackbar--success': type === 'success',
    'de-snackbar--warning': type === 'warning',
  }"
>
  <span class="de-snackbar__icon-wrapper">
    @if (type === 'warning') {
      <svg
        class="de-snackbar__icon"
        viewBox="0 0 30 30"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <defs>
          <path
            d="M15.022 20.246c1.328 0 2.31.98 2.31 2.254v.052c0 1.273-.981 2.255-2.31 2.255-1.325 0-2.308-.982-2.308-2.255V22.5c0-1.275.982-2.254 2.308-2.254zm1.3-14.248c.719 0 1.142.585 1.064 1.353l-1.141 9.976c-.081.716-.557 1.168-1.221 1.168-.665 0-1.141-.452-1.222-1.168l-1.14-9.976c-.08-.768.344-1.353 1.063-1.353z"
            id="a"
          />
        </defs>
        <g fill="none" fill-rule="evenodd">
          <circle fill="#FFF" cx="15" cy="15" r="15" />
          <use fill="#9E1B32" xlink:href="#a" />
        </g>
      </svg>
    }
    @if (type !== 'warning') {
      <svg
        class="de-snackbar__icon"
        viewBox="0 0 68 68"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Rebate-Card-Validated" transform="translate(-558.000000, -33.000000)">
            <g id="ic_check_circle">
              <g transform="translate(551.000000, 26.000000)">
                <polygon id="Bounds" points="0 0 82 0 82 82 0 82"></polygon>
                <path
                  d="M41,7 C22.232,7 7,22.232 7,41 C7,59.768 22.232,75 41,75 C59.768,75 75,59.768 75,41 C75,22.232 59.768,7 41,7 L41,7 Z M58.5255107,24.6661991 C57.8367605,23.8478982 56.6298078,23.7093283 55.7729697,24.3480621 C55.3654592,24.65308 45.9336813,31.7841043 34.0158431,48.0099109 L26.2378856,42.1210968 C25.4179449,41.5004017 24.2610085,41.5946949 23.5542196,42.3416609 C22.8466108,43.0878069 22.8121733,44.2463831 23.4763253,45.0327062 L33.8395559,57.3104984 C34.2257479,57.7688452 34.7931469,58.0271265 35.3810444,58.0271265 C35.4958361,58.0271265 35.6089879,58.0172873 35.7229597,57.9976087 C36.4289286,57.8770774 37.017646,57.3900326 37.2701878,56.720961 C37.3251238,56.5758315 42.9048203,42.090759 58.3697219,27.4310391 C59.1453858,26.6963723 59.2142609,25.4836799 58.5255107,24.6661991"
                  id="Icon"
                  fill="#FFFFFF"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </svg>
    }
  </span>
  <span> <span [innerHTML]="text"></span></span>
  @if (showCloseIcon) {
    <button class="de-snackbar__close--x de-snackbar__close" (click)="fadeOut()">
      <svg
        class="de-snackbar__icon"
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 14 14"
        style="enable-background: new 0 0 18 18"
        xml:space="preserve"
      >
        <style type="text/css">
          .st0 {
            fill: #ffffff;
          }
        </style>
        <g id="Symbols">
          <g id="Upload" transform="translate(-1151.000000, -23.000000)">
            <g id="Group-10">
              <g transform="translate(1094.000000, 23.000000)">
                <g transform="translate(57.000000, 0.000000)">
                  <g id="Mask">
                    <path
                      class="st0"
                      d="M7,5.7l5.4-5.4c0.4-0.4,1-0.4,1.3,0c0.4,0.4,0.4,1,0,1.3L8.3,7l5.4,5.4c0.4,0.4,0.4,1,0,1.3c-0.4,0.4-1,0.4-1.3,0L7,8.3l-5.4,5.4c-0.4,0.4-1,0.4-1.3,0c-0.4-0.4-0.4-1,0-1.3L5.7,7L0.3,1.6c-0.4-0.4-0.4-1,0-1.3s1-0.4,1.3,0L7,5.7z"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </button>
  }
  @if (linkText?.length && !showCloseIcon) {
    <button class="de-snackbar__close" (click)="fadeOut()">
      {{ linkText }}
    </button>
  }
</div>
